import { useLocation } from 'react-router-dom';
import './App.css';
import NavBar from './components/NavBar';
import About from './components/About';
import Home from './components/Home';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
// import { useEffect, useState } from 'react';
// import Avatar from '@mui/material/Avatar';
// import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';

function App() {
  const { hash } = useLocation();

  // const [showButton, setShowButton] = useState(false);

  // useEffect(() => {
  //   const handleScrollButtonVisibility = () => {
  //     window.scrollY > 0.8 * window.innerHeight ? setShowButton(true) : setShowButton(false);
  //   };
  //   window.addEventListener('scroll', handleScrollButtonVisibility);
  //   return () => {
  //     window.removeEventListener('scroll', handleScrollButtonVisibility);
  //   };
  // }, []);

  // const handleScrollToTop = () => {
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  // };

  return (
      <div className="App">
        <NavBar hash={hash} />
        {/* {showButton && (
          <div className='scroll-button'>
            <Avatar onClick={handleScrollToTop} sx={{ cursor: 'pointer', opacity: 0.8 }}>
              <ArrowUpwardOutlinedIcon />
            </Avatar>
          </div>
        )} */}
        <Home />
        <About />
        <Experience />
        <Projects />
        <Contact />
      </div>
    
  );
}

export default App;
